var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('PageHeader',{attrs:{"contextStyle":_vm.contextStyle}}),_c('EventList',{attrs:{"routeState":{ siteView:false, siteEdit:true, view:false, edit:true, add:true, state: 'modifier' },"eve_xxx_id":'all',"table_id":'zon,tsk',"typfilter":'MEV',"stafilter":'TSK',"title":"Devis"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }